import React from "react";
import "./Green_round_btn.css";
import { Button } from "react-bootstrap";

function Green_round_btn({ btnText, onClick }) {
  return (
    <>
      <section className="Green_round_btn_holder">
        <Button className="Green_round_btn" onClick={onClick}>
          {btnText}
        </Button>
      </section>
    </>
  );
}

export default Green_round_btn;
